export default __webpack_public_path__ + "static/media/american-226445.37876995.svg";